import React from 'react'
import Link from 'gatsby-link'

import { Constrain } from '../@primitives/constrain'

import Logo from '../Logos/avi_red.svg'
import WordMark from '../Logos/avi_text.svg'

import styled, { css } from 'react-emotion'
import { colors, fonts } from '../../styles/vars'
import { Button } from '../@primitives/button'

const HeaderStyles = styled('div')`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 30px;
  align-items: center;
  font-family: ${fonts.heading};
  font-weight: bold;
  font-size: 16px;
  line-height: 1.5;
  position: relative;
  z-index: 2;

  div {

    &.nav {
      margin-left: auto;

      @media (max-width: 768px) {
        display: none;
        width: 100%;
        max-height: 0;
        height: 0;
        opacity: 0;
        transition: all 0.15s ease-in-out;
      }

      &.open {
        @media (max-width: 768px) {
          display: block;
          padding-top: 30px;
          max-height: unset;
          height: unset;
          opacity: 1;
          transition: all 0.15s ease-in-out;
          grid-column: span 2;
        }
      }
    }
  }

  .mobileNav {
    display: block;
    margin-left: auto;

    button {
      appearance: none;
      border: none;
    }

    @media (min-width: 769px) {
      display: none;
    }
  }

  nav {
  text-align: right;

    ul {
      text-align: left;
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: inline-block;
        position: relative;

        @media (max-width: 768px) {
          display: block;
        }

        &:not(:last-of-type) {
          margin-right: 10px;
        }

        &:hover ul {
          max-height: unset;
          height: unset;
          opacity: 1;
          overflow: visible;
          transition: all 0.25s ease-in-out;
        }

        ul {
          position: absolute;
          max-height: 0;
          height: 0;
          opacity: 0;
          background-color: ${colors.white};
          padding: 10px;
          transition: all 0.25s ease-in-out;
          overflow: hidden;
          min-width: 150px;

          li {
            display: block;
          }

          @media (max-width: 768px) {
            position: relative;
            height: unset;
            max-height: unset;
            opacity: 1;
            padding: 10px 20px;
          }
        }
      }

      a:not(.button) {
        color: ${colors.black};
        display: block;
        padding: 10px;
        text-decoration: none;
        border-bottom: 1px solid transparent;

        &.active,
        &:hover {
          @media (min-width: 769px) {
            border-bottom: 1px solid ${colors.primaryD};
          }
          @media (max-width: 768px) {
            color: ${colors.primaryD};
          }
        }
      }
    }
  }
`

class Header extends React.Component {

  constructor() {
    super()
    this.state = {
      mobileNav: false
    }
  }

  toggleMobileNav = () => {
    this.setState({ mobileNav: !this.state.mobileNav })
  }

  findArrayElementByCategory = (array, category) => {
    return array.find((element) => {
      return element.edges[0].frontmatter.category === category;
    })
  }

  render() {
    return(
      <Constrain thin>
        <HeaderStyles>
          <div>
            <Link
              to="/"
            >
              <img
                src={Logo}
                alt="AVI Logo"
                className={css`
                  vertical-align: middle;
                `}
              />
              <img
                src={WordMark}
                className={css`
                  display: none;

                  @media (min-width: 1100px) {
                    display: inline-block;
                    vertical-align: middle;
                  }
                `}
                alt=""
              />
            </Link>
          </div>
          <div className="mobileNav">
            <button onClick={this.toggleMobileNav}>
              <i className="far fa-bars fa-fw fa-lg" />
            </button>
          </div>
          <div className={`nav${this.state.mobileNav ? ' open' : ''}`}>
            <nav>
              <ul>
                <li><a href="/control-valves">Control Valves</a></li>
                <li><a href="/blow-valves">Blow Valves</a></li>
                <li><a href="/liquor-valves">Liquor Valves</a></li>
                <li><a href="/capping-valves">Capping Valves</a></li>
                {/*{this.props.data.products.map((product, i) => {*/}
                {/*  if (product.edges[0].node.frontmatter.category === 'Control Valves') {*/}
                {/*    return (*/}
                {/*      <li key={i}>*/}
                {/*        <Link to={product.edges[0].node.frontmatter.path}>*/}
                {/*          {product.edges[0].node.frontmatter.category}*/}
                {/*        </Link>*/}
                {/*      </li>*/}
                {/*    )*/}
                {/*  }*/}
                {/*})}*/}

                {/*{this.props.data.products.map((product, i) => {*/}
                {/*  if (product.edges[0].node.frontmatter.category !== 'Control Valves') {*/}
                {/*    return (*/}
                {/*      <li key={i}>*/}
                {/*        <Link to={product.edges[0].node.frontmatter.path}>*/}
                {/*          {product.edges[0].node.frontmatter.category}*/}
                {/*        </Link>*/}
                {/*      </li>*/}
                {/*    )*/}
                {/*  }*/}
                {/*})}*/}

                {(this.props.data.more && this.props.data.more.length) &&
                  <li>
                      More Valves
                    <ul>
                      {this.props.data.more.map((product, i) => (
                        <li key={i}>
                          <Link to={product.edges[0].node.frontmatter.path}>
                            {product.edges[0].node.frontmatter.category}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                }

                <li>
                  <Link
                    to="/about"
                  >
                    About AVI
                  </Link>
                </li>
                <li>
                  <Button
                    to="/contact"
                    className={"button"}
                  >
                    Request A Quote
                  </Button>
                </li>
              </ul>
            </nav>
          </div>
        </HeaderStyles>
      </Constrain>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js